import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

interface CountUpAnimationProps {
  end: number;
  duration?: number;
  decimals?: number;
  prefix?: string;
  suffix?: string;
  separator?: string;
  className?: string;
}

const CountUpAnimation: React.FC<CountUpAnimationProps> = ({
  end,
  duration = 2.5,
  decimals = 0,
  prefix = '',
  suffix = '',
  separator = ',',
  className = ''
}) => {
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  return (
    <span ref={ref} className={className}>
      {inView && (
        <CountUp
          end={end}
          duration={duration}
          decimals={decimals}
          prefix={prefix}
          suffix={suffix}
          separator={separator}
        />
      )}
      {!inView && <span>{prefix}0{suffix}</span>}
    </span>
  );
};

export default CountUpAnimation;

